import React, { useMemo } from "react";

import { Config } from "kadow-jetpack-model";
import { useEventsSelector } from "../../../../redux/actions/wheel";

import { buildGamesList } from "../../../../utils/helpers/buildGamesList";
import GameCardPreview from "../../../23_GameCardPreview/GameCardPreview";
import TSUtils from "../../../../utils/helpers/TSUtils";
import { DEFAULT_EVENTS, NEUTRAL_EVENT_ID } from "../../../../utils/constants";
import { tt } from "../../../../utils/i18n/i18n";
import UpsellContainer from "./UpsellContainer";
import { GameThumbnailDTO } from "../../../../model/GameDTO";

interface Props {
  includeGamesOfChance: boolean;
  includePerformanceGames: boolean;
  includeSkins: boolean;
  config?: Config | null;
}

const UPSELL_ITEM_COUNT = 9;

let gamesListCache: GameThumbnailDTO[] | null = null;

export default function GameConfigUpsell(props: Props) {
  const events = useEventsSelector();

  const gamesList = useMemo(() => {
    if (!props.config) {
      return [];
    }

    if (gamesListCache) {
      return gamesListCache;
    }

    const eventsToRandomize = [...events];

    const neutral = DEFAULT_EVENTS.find((e) => e._id === NEUTRAL_EVENT_ID);

    if (neutral) {
      eventsToRandomize.push(neutral);
    }

    const gameList = buildGamesList(
      props.includeGamesOfChance,
      props.includePerformanceGames,
      props.includeSkins,
      props.config,
      true,
      eventsToRandomize,
      true
    );

    gamesListCache = TSUtils.shuffleArray(
      TSUtils.shuffleArray(TSUtils.shuffleArray(gameList))
    );

    return gamesListCache.slice(0, UPSELL_ITEM_COUNT);
  }, [
    props.includeGamesOfChance,
    props.includePerformanceGames,
    props.includeSkins,
    props.config,
    events
  ]);

  return (
    <UpsellContainer title={tt("upsell_game_title")}>
      {gamesList.map((game) => (
        <GameCardPreview gameCardConfig={game.config} eventId={game.eventId} />
      ))}
    </UpsellContainer>
  );
}
